import { Component } from '@angular/core';
import { BaseModalComponent } from '../../../../../core/modals/components/base-modal/base-modal.component';
import { ModalsActions } from '../../../../../core/modals/actions/modals.actions';
import { UserApiActions } from '../../../../../core/users/actions/user-api.actions';

@Component({
  selector: 'app-confirm-delete-user-modal',
  templateUrl: './confirm-delete-user-modal.component.html',
})
export class ConfirmDeleteUserModalComponent extends BaseModalComponent<string> {
  public secondStep = false;

  handleDeleteClick(): void {
    if (!this.data) {
      return;
    }

    if (!this.secondStep) {
      this.secondStep = true;
      return;
    }

    this.store.dispatch(UserApiActions.deleteUser({ userId: this.data }));
    this.store.dispatch(ModalsActions.closeConfirmDeleteUserModal());
  }

  handleCloseClick(): void {
    this.store.dispatch(ModalsActions.closeConfirmDeleteUserModal());
  }
}
